import moment from 'moment'
import React from 'react'
import { NavigateFunction } from 'react-router'

import { usePSNavigate } from '../../hooks/usePSNavigate'
import { ComputeFactory } from '../../models/ComputeFactory'
import { Invoice } from '../../models/Invoice'
import { Package } from '../../models/Package'
import { Payment } from '../../models/Payment'
import { RecordFactory } from '../../models/RecordFactory'
import { Subscription } from '../../models/Subscription'
import { Transaction } from '../../models/Transaction'
import { currencyFormat } from '../../utils/numbers'
import { PocketComponent, PocketComponentProps, usePSComponent } from '../PocketComponent'
import { AppHeader } from '../app/AppHeader'
import { ContactAvatar } from '../contacts/ContactAvatarV1'

type Data = {
    title: string
    payments: Payment[]
}

const viewWillAppear = async (base: PocketComponent, navigate?: NavigateFunction) => {
    if (!base.urlParams.recordType || !base.urlParams.recordID) {
        navigate?.('/', { replace: true })
        return
    }
    let title = ''
    let record: Transaction | undefined = undefined
    let payments: Payment[] = []
    switch (base.urlParams.recordType) {
        case 'invoice':
            title = 'Invoice'
            record = await RecordFactory.getInstance().loadInvoice(base.urlParams.recordID)
            payments = await ComputeFactory.getInstance().fetchInvoicePayments(record as Invoice)
            break
        case 'package':
            title = 'Package'
            record = await RecordFactory.getInstance().loadPackage(base.urlParams.recordID)
            payments = await ComputeFactory.getInstance().fetchPackagePayments(record as Package)
            break
        case 'subscription':
            title = 'Subscription'
            record = await RecordFactory.getInstance().loadSubscription(base.urlParams.recordID)
            payments = await ComputeFactory.getInstance().fetchSubscriptionPayments(
                record as Subscription
            )
            break
    }
    if (!title || !record) {
        navigate?.('/', { replace: true })
        return
    }

    return {
        title,
        record,
        payments,
    }
}

const render = ({ data, base }: PocketComponentProps<any>) => {
    const navigate = usePSNavigate()
    const payments = data.payments
    const title = data.title

    return (
        <AppHeader title={title} showBackButton middleWidget={null}>
            <div className="servicesSettings" style={{ width: '680px' }}>
                <div className="header">
                    <h1>Payments</h1>
                </div>
                <div className="separator" />
                <div className="form">
                    {payments?.map((payment: Payment) => {
                        const client = payment.client
                        return (
                            <div key={`payment-card-${payment.id}`} className="serviceCard">
                                {client && <ContactAvatar user={client} />}
                                <div className="details">
                                    <div className="name">{client?.name}</div>
                                    <div className="rate">
                                        {moment(payment.createdDate).format('MMMM DD, YYYY')}
                                    </div>
                                </div>
                                <div className="name" style={{ marginLeft: 'auto' }}>
                                    {currencyFormat(payment.amount, true)}
                                </div>
                                <div
                                    className="view"
                                    style={{ marginLeft: '24px' }}
                                    onClick={() => navigate(`/payments/${payment.id}`)}
                                >
                                    View
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </AppHeader>
    )
}

export const PaymentsPage = usePSComponent(render, viewWillAppear)
